/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { EncounterStartType } from "./EncounterStartType";

/**
 * Request schema for creating a Curai visit from a Nori conversation
 */
export interface CreateCuraiVisitRequest {
  /** The ID of the Nori conversation */
  conversation_id: string;
  /** The type of encounter to start */
  encounter_type?: EncounterStartType;
  /** Clinic request ID used to resolve the visit title from the SNOMED code */
  clinic_request_id?: string | null;
  /** Optional ClinicRequest ID associated with this visit */
  origin_clinic_request_id?: string | null;
  /** Active user progression containing the visit's payment decision */
  user_progression_id: string;
}
